import { motion } from "framer-motion";
import { ARCH_IMAGE } from "@/data/content";

const fade = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0 },
};

export const About = () => {
  return (
    <section
      data-testid="about-section"
      id="about"
      className="relative py-24 md:py-36 bg-[#faf6ef]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
          {/* Text */}
          <motion.div
            variants={fade}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <p className="font-body-lux text-xs uppercase tracking-[0.35em] text-[#9c7d44] mb-8">
              The Idea
            </p>
            <h2 className="font-serif-lux font-light leading-[1.1] tracking-tight text-[#1f3a2e] text-4xl sm:text-5xl lg:text-[3.4rem]">
              We are travel designers,
              <br />
              <span className="text-[#b8965a] italic">not package sellers.</span>
            </h2>
            <div className="mt-10 space-y-6 max-w-xl">
              <p className="font-body-lux text-base md:text-lg font-light text-[#47564d] leading-relaxed">
                A package treats every traveller the same. A design begins with
                you — how you like to move, what stirs your curiosity, and the
                pace that feels like a true holiday.
              </p>
              <p className="font-body-lux text-base md:text-lg font-light text-[#47564d] leading-relaxed">
                From the dunes of Liwa to the terraces above the Dubai skyline,
                every detail is chosen with intention and quietly arranged so
                that you experience the UAE exactly as you imagined it — only
                better.
              </p>
            </div>

            <div className="mt-12 flex flex-wrap gap-x-12 gap-y-8">
              {[
                { k: "100%", v: "Bespoke Itineraries" },
                { k: "24×7", v: "Dedicated Support" },
                { k: "0", v: "Off-the-shelf Packages" },
              ].map((stat) => (
                <div key={stat.v} data-testid={`about-stat-${stat.v}`}>
                  <div className="font-serif-lux text-4xl text-[#b8965a]">
                    {stat.k}
                  </div>
                  <div className="font-body-lux text-xs uppercase tracking-[0.2em] text-[#6b7a70] mt-2">
                    {stat.v}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Image with arch frame */}
          <motion.div
            variants={fade}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <div className="absolute -inset-3 border border-[#b8965a]/35 z-0" />
              <div
                className="relative z-10 overflow-hidden"
                style={{
                  borderTopLeftRadius: "9999px",
                  borderTopRightRadius: "9999px",
                }}
              >
                <img
                  src={ARCH_IMAGE}
                  alt="Traditional Arabic architecture"
                  className="w-full h-[440px] md:h-[560px] object-cover"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
